import React, { Component, Fragment } from 'react'
import styles from './styles.scss'

/** Components */
import { PopOver } from '@/components/commons/PopOver'
import ColorPicker from '../../ColorPicker/index'


class FontColor extends Component {
  state = {
    showOptions: false,
    color: '#000',
  }

  changeColor = valor => {
    const { onChange } = this.props
    this.setState({ color: valor })
    onChange(valor)
  }

  render() {
    const { showOptions } = this.state

    return (
      <Fragment
      >
        <button
          onMouseDown={() => this.setState({ showOptions: true })}
          className={'ba-color-white1 ' + styles['input']}
        >A</button>

        {showOptions && (
          <PopOver
            className={'ba-w-100 ' + styles['wrapper-text-color__palette']}
            hidePopover={() => this.setState({ showOptions: false })}
          >
            <ColorPicker
              color={this.state.color}
              onChange={({ hex }) => this.changeColor(hex)}
            />
          </PopOver>
        )}
      </Fragment>
    )
  }
}

export default FontColor


// WEBPACK FOOTER //
// ./src/components/editors/FontColor/index.js